import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from './api';

/**
 * Generates month options dynamically from the first recorded sale to current month + 12.
 * Fetches /api/month-range once, caches the result.
 * Identical logic for Desktop, Mobile, Admin, and Commercial.
 */

let cachedOptions = null;
let fetchPromise = null;

function generateMonths(firstMonth, currentMonth) {
    const [fy, fm] = firstMonth.split('-').map(Number);
    const [cy, cm] = currentMonth.split('-').map(Number);
    const start = new Date(fy, fm - 1, 1);
    const end = new Date(cy, cm - 1 + 12, 1); // current + 12 months
    const opts = [];
    const d = new Date(start);
    while (d <= end) {
        const value = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
        const raw = d.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
        const label = raw.charAt(0).toUpperCase() + raw.slice(1);
        opts.push({ value, label });
        d.setMonth(d.getMonth() + 1);
    }
    return opts;
}

function fallbackMonths() {
    const now = new Date();
    const start = new Date(now.getFullYear() - 1, now.getMonth(), 1);
    const end = new Date(now.getFullYear() + 1, now.getMonth(), 1);
    const opts = [];
    const d = new Date(start);
    while (d <= end) {
        const value = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
        const raw = d.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
        const label = raw.charAt(0).toUpperCase() + raw.slice(1);
        opts.push({ value, label });
        d.setMonth(d.getMonth() + 1);
    }
    return opts;
}

export function useMonthOptions() {
    const [options, setOptions] = useState(() => cachedOptions || fallbackMonths());

    useEffect(() => {
        if (cachedOptions) { setOptions(cachedOptions); return; }
        if (!fetchPromise) {
            fetchPromise = axios.get(`${API_URL}/api/month-range`, { withCredentials: true })
                .then(res => {
                    const data = res.data;
                    cachedOptions = generateMonths(data.first_month, data.current_month);
                    return cachedOptions;
                })
                .catch(() => {
                    cachedOptions = fallbackMonths();
                    return cachedOptions;
                });
        }
        fetchPromise.then(opts => setOptions(opts));
    }, []);

    return options;
}
